
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Holidays extends Vue {
  grid = {};
  url = "/api/holiday/group/grid?rows=20";
  showFilter = false;
  name = "";
  country = "";
  year = "";
  menu1 = false;
  filterUrl = "";
  page = 1;
  showConfirmDelete = false;
  deleteConfirmed = false;
  toDeleteHoliday = null;
  on = null;
  date = null;

  get loading() {
    return common.loading;
  }

  async mounted() {
    try {
      this.grid = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
  }

  async showPage(page) {
    this.page = page;
    this.grid = await doGet(this.url + this.filterUrl + "&page=" + page);
    common.setLoading(false);
  }

  async clear() {
    this.name = "";
    this.year = "";
    this.country = "";
    this.page = 1;
    this.search();
  }

  async search() {
    this.filterUrl = "";
    if (this.name) this.filterUrl += "&name=" + this.name;
    if (this.year) this.filterUrl += "&year=" + this.year;
    if (this.country) this.filterUrl += "&country=" + this.country;
    common.setLoading(true);
    await this.showPage(1);
  }

  async deleteHoliday(holiday) {
    common.setLoading(true);
    try {
      await doGet("/api/holiday/group/" + holiday._id + "/delete");
      common.showMessage("Deleted Successfully");
      await this.search();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }
}
